import { User } from "../../user";

// ワークフロー実施者model
export class WorkflowOperator {

  public user: User;

  public professionName: string;

}
